import createStore from "./store";
import { createClient } from "./apollo-client/factory";
import { createManager } from "./auth/mangerFactory";

export const reduxStore = createStore();
export const apolloClient = createClient(reduxStore);
export const authManager = createManager(apolloClient, reduxStore);
